import { render, staticRenderFns } from "./appendix-ii.vue?vue&type=template&id=43a62812"
import script from "./appendix-ii.vue?vue&type=script&lang=js"
export * from "./appendix-ii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotInternal: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Internal/Internal.vue').default})
